<template>
  <AppTooltip v-bind="$attrs">
    <template #activator="{ props }">
      <app-material-icon
        v-bind="props"
        name="help"
        color="icon-secondary"
        class="mx-1"
        size="xs"
      />
    </template>
    <span v-html="text"></span>
  </AppTooltip>
</template>

<script>
import AppTooltip from './AppTooltip.vue'
/**
 * @displayName AppHelpTooltip
 */
/**
 * Default Help tooltip.
 * Uses the AppTooltip component.
 */
export default {
  name: 'AppHelpTooltip',
  components: {
    AppTooltip,
  },
  inheritAttrs: false,
  props: {
    /**
     * Text displayed in tooltip
     */
    text: {
      type: String,
      required: true,
    },
  },
}
</script>
